import React from "react";
import { Avatar, Tooltip } from "antd";
import FamilyMembersList from "./FamilyMemberList";
import {
  AutoRenewIcon,
  MemberNoteIcon,
  RegisteredMemberIcon,
} from "../../../../utils/icons";
import { LockOutlined } from "@ant-design/icons";
import "./Members.css";

const MemberName = ({
  record,
  name,
  groupData,
  activePackages,
  hasPackages,
  familyMembers,
}) => {
  const nameInitials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  let userRole = record.userRole || "";

  if (record.userRole === "admin") {
    userRole = "admin";
  } else if (
    // record.userRole === "member" &&
    groupData.requireMembershipPackage
  ) {
    let packId = record.package;

    const hasActivePackage =
      packId &&
      packId?.length > 0 &&
      record?.packageSeason &&
      activePackages.find(
        (pkg) => pkg.key === `${record.package}|${record.packageSeason}`,
      );

    if (hasPackages && !hasActivePackage) {
      if (groupData.regCodeRole === "fan") {
        userRole = "fan";
      } else {
        userRole = "inactive";
      }
    }

    if (!record.userRole && hasPackages && hasActivePackage) {
      userRole = "member";
    }
  }

  return (
    <div className="d-flex">
      <div>
        {record.profileImage ? (
          <Avatar size="large" src={record.profileImage} />
        ) : (
          <Avatar
            size="large"
            style={{ backgroundColor: "var(--primary-background)" }}
          >
            {nameInitials}
          </Avatar>
        )}
      </div>

      <div className="d-flex gap-2 justify-content-between w-100">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ marginLeft: 20, fontWeight: "bold" }}>
            {record.name}
          </span>
          <span style={{ marginLeft: 20, fontSize: 14 }}>
            {record.title || ""}
          </span>
          <span style={{ marginLeft: 20, fontSize: 14 }}>{userRole}</span>
        </div>
        <div className="member-tags">
          {familyMembers[
            record?.familyMembershipId || record?.membershipNumber
          ] && (
            <FamilyMembersList
              familyData={
                familyMembers[
                  record?.familyMembershipId || record?.membershipNumber
                ]
              }
            />
          )}

          {record &&
            record?.registeredOnChantDate &&
            !record?.hideGroup && (
              <Tooltip
                placement="top"
                title={() => <div>Registered on Chant</div>}
              >
                <div className="flex-center">
                  <img
                    src={RegisteredMemberIcon}
                    alt="registered-member"
                    style={{ width: 18, height: 18 }}
                  />
                </div>
              </Tooltip>
            )}

          {record && record?.subscriptionDetail?.status === "active" && (
            <Tooltip
              placement="top"
              title={() => (
                <div
                  style={{
                    height: "fit-content",
                    maxWidth: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  Auto-Renewal
                </div>
              )}
            >
              <div className="flex-center">
                <img
                  src={AutoRenewIcon}
                  alt="auto-renew-note"
                  style={{ width: 18, height: 18 }}
                />
              </div>
            </Tooltip>
          )}

          {record && record.notes && (
            <Tooltip
              placement="top"
              title={() => (
                <div
                  style={{
                    height: "fit-content",
                    maxWidth: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {record.notes}
                </div>
              )}
            >
              <img
                src={MemberNoteIcon}
                alt="member-note"
                style={{ width: 18, height: 18 }}
              />
            </Tooltip>
          )}
          {record && record.lockStatus && <LockOutlined />}
        </div>
      </div>
    </div>
  );
};

export default MemberName;
